import angular from 'angular';
import _ from 'lodash';

class stockSoftwareDetail {
    /*  @ngInject */

    constructor(
        $state,
        logger,
        CommunitySvc,
        AuthSvc,
        $scope,
        $window,
        $translate,
        uiGridExporterService,
        $stateParams,
        EMAIL_REGEXP
    ) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.CommunitySvc = CommunitySvc;
        this.$scope = $scope;
        this.$window = $window;
        this.$translate = $translate;
        this.uiGridExporterService = uiGridExporterService;
        this.$stateParams = $stateParams;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
    }

    $onInit() {
        this.isUniqueName = false;
        this.transmissionModes = [{ code: 'Mail' }, { code: 'Web service' }, { code: 'Mail et Web service' }];

        if (this.mode === 'edit') {
            this.stockSoftware.modeMail === true && this.stockSoftware.modeWebService === true
                ? (this.stockSoftware.transmissionMode = 'Mail et Web service')
                : this.stockSoftware.modeMail === true
                ? (this.stockSoftware.transmissionMode = 'Mail')
                : (this.stockSoftware.transmissionMode = 'Web service');
        } else {
            this.stockSoftware = {};
            this.stockSoftware.deleted = false;
            this.stockSoftware.countryCode = 'FR';
        }

        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    reloadRegSchemes(country) {
        this.reloadRegSchemesonEdit(country ? country.code : null);
    }

    reloadRegSchemesonEdit(countryCode) {
        if (countryCode) {
            this.RegistrationSchemesDA.getByCountry(countryCode).then(regShemes => {
                this.regSchemes = regShemes;
                this._initRegSchemes();
            });
        }
    }

    _initRegSchemes() {
        this.natRegSchemes = _.filter(this.regSchemes, { scope: 'national' });
    }

    isEmail(value) {
        // Regexp utilisé dans Angular pour valider les input[type=email]
        return this.EMAIL_REGEXP.test(value.text);
    }

    isUnique() {
        this.CommunitySvc.checkStockSoftwareName(this.stockSoftware.name).then(data => {
            this.isUniqueName = !!data;
            this.submitDisabled = this.isUniqueName === true;
        });
    }

    save() {
        this.stockSoftware.contactEmails = _.map(this.stockSoftware.contactEmails, emails => emails.text);
        this.stockSoftware.presalesEmails = _.map(this.stockSoftware.presalesEmails, emails => emails.text);
        this.stockSoftware.techEmails = _.map(this.stockSoftware.techEmails, emails => emails.text);
        this.stockSoftware.alertEmails = _.map(this.stockSoftware.alertEmails, emails => emails.text);

        this.stockSoftware.transmissionMode === 'Mail et Web service'
            ? ((this.stockSoftware.modeMail = true), (this.stockSoftware.modeWebService = true))
            : this.stockSoftware.transmissionMode === 'Mail'
            ? ((this.stockSoftware.modeMail = true), (this.stockSoftware.modeWebService = false))
            : ((this.stockSoftware.modeMail = false), (this.stockSoftware.modeWebService = true));

        if (this.form.$valid && this.mode === 'edit') {
            this.CommunitySvc.updateStockSoftware(this.stockSoftware).then(
                data => {
                    this.logger.success('success.update', data, null, {
                        entityName: 'Le logiciel',
                    });
                    this.$state.go('community.details.stock-software-list');
                },
                error => {
                    this.logger.error('error.update', error);
                }
            );
        } else if (this.form.$valid && this.mode === 'create') {
            this.CommunitySvc.createStockSoftware(this.stockSoftware).then(
                data => {
                    this.logger.success('success.create', data, null, {
                        entityName: 'Le logiciel',
                    });
                    this.$state.go('community.details.stock-software-list');
                },
                error => {
                    this.logger.error('error.create', error);
                }
            );
        }
    }

    cancel() {
        this.$state.go('community.details.stock-software-list');
    }
}

angular.module('app.community').component('stockSoftwareDetail', {
    templateUrl: require('./stock-software-detail.html'),
    controller: stockSoftwareDetail,
    bindings: {
        initMenuConsult: '<',
        community: '<',
        stockSoftware: '<',
        mode: '<',
        countries: '<',
    },
});
